import {BarGraphShimmer} from "./Component";

export default BarGraphShimmer;